import { Component } from "react";

// Minimal reusable error boundary. Keeps the rest of the page usable when a
// child (e.g. the Leaflet map) throws at runtime.
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        // eslint-disable-next-line no-console
        console.error("ErrorBoundary caught:", error);
    }

    componentDidUpdate(prevProps) {
        // Reset when the reset key changes (e.g. a new search), so the boundary
        // can recover instead of staying in the error state forever.
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false });
        }
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback || null;
        }
        return this.props.children;
    }
}
